const moment = require('moment')

export const DateFormat = {
  methods: {
    formatDate(time) {
      const createdAt = moment(time)
      const midnight = moment().set({hour:0,minute:0,second:0,millisecond:0})
      
      if (createdAt.isBefore(midnight)) {
          return new Date(time).toLocaleDateString()
      } else {
          const dateString = new Date(time).toLocaleTimeString()
          return dateString.substring(0, dateString.length - 3)
      }
    }
  },
}